import { Component, OnInit, ViewChild } from "@angular/core";
import { BaseComponent } from "../../../shared/components/base.component";
import { ActivatedRoute, ChildActivationEnd, NavigationEnd, NavigationStart, ResolveEnd, RouteConfigLoadEnd, Router, RoutesRecognized } from "@angular/router";
import { UserPreferencesService } from "../../../shared/service/user-preferences.service";
import { AuthorizationService } from "../../../shared/service/authorization.service";
import { LocalStorageService } from "../../service/local-storage.service";
import { ApplicationConfig } from "../../../../config/application.config";
import { Observable } from "rxjs";
import { LocalizationService } from "../../service/localization.service";
import { ChangeCultureConfirmationModalComponent } from "../change-culture-confirmation-modal/change-culture-confirmation-modal.component";
import { RefreshTokenService } from "../../service/refresh-token.service";
import { InterventionTeamService } from "../../service/interventionTeamService";
import { InterventionTeam } from "../../model/interventionTeam";
import { IssueDialogComponent } from "src/app/modules/issues/issue-dialog/issue-dialog.component";
import { SidenavComponent } from 'ng-uikit-pro-standard';
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: "app-user-navbar",
  templateUrl: "./user-navbar.component.html",
  styleUrls: ["./user-navbar.component.scss"]
})
export class UserNavbarComponent extends BaseComponent implements OnInit {
  @ViewChild(ChangeCultureConfirmationModalComponent) changeCultureConfirmationModal: ChangeCultureConfirmationModalComponent;
  @ViewChild('sidenav', { static: true }) sidenav: SidenavComponent

  public logoUrl: string;
  public isSettingsButtonActive: boolean;
  public isAccountButtonActive: boolean;
  public interventionTeams: InterventionTeam[] = [];
  public areTeamsLoaded: boolean;
  public supportedLanguages$: Observable<string[]>;
  public selectedTeamLabel: string;
  public selectedTeamId: string;
  public showMenu: boolean = true;
  public buildingId: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userPreferencesService: UserPreferencesService,
    private authService: AuthorizationService,
    private localStorageService: LocalStorageService,
    private applicationConfig: ApplicationConfig,
    private localizationService: LocalizationService,
    private refreshTokenService: RefreshTokenService,
    private interventionTeamService: InterventionTeamService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private translate: TranslateService
  ) {
    super();
  }

  ngOnInit() {
    this.logoUrl = this.userPreferencesService.getCompanyLogoUrl();
    this.resetButtons();
    this.selectButtonDependingOfRoute(this.router.url);
    this.interventionTeamService.selectedInterventionTeam.subscribe(team => {
      this.selectedTeamId = team.id;
      this.selectedTeamLabel = team.label;
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.selectButtonDependingOfRoute(event.url);
      }
      if(event instanceof RoutesRecognized){
        this.buildingId = event.state.root.firstChild.params.buildingId;
      }
    });
    this.supportedLanguages$ = this.localizationService.getSupportedLanguages();
    this.interventionTeamService.getTeams().subscribe(teams => {
      this.interventionTeams = teams;
      if (teams.length > 0) {
        this.interventionTeamService.setTeam(teams[0]);
        window.dispatchEvent(new Event('resize')); //needs to be called to correctly load the navbar
      }
      this.areTeamsLoaded = true;
    });
  }

  public onLanguageClick(value) {
    this.changeCultureConfirmationModal.show(value);
  }

  public onCultureChangeConfirmed(value) {
    this.localizationService.setCulture(value).subscribe(() => {
      this.refreshTokenService.refreshToken().subscribe(response => {
        if (response && response.accessToken) {
          this.authService.initSession(response);
          window.location.href = window.location.href;
        }
      });
    });
  }

  public isLanguageSelected(value: string): boolean {
    return value === this.localStorageService.getCulture();
  }

  public getLanguageLocalization(value: string): string {
    return "lang_" + value.replace("-", "_");
  }

  public getUsername(): string {
    return `${this.localStorageService.getFirstname()} ${this.localStorageService.getLastname()}`;
  }

  public getCompanyLogoUrl(): string{
    return this.userPreferencesService.getCompanyLogoUrl();
  }

  public getUserEmail(): string {
    return this.localStorageService.getEmail();
  }

  public selectButtonDependingOfRoute(url: string) {
    this.isAccountButtonActive = url.includes("account");
    this.isSettingsButtonActive = url.includes("settings");
  }

  public logout() {
    this.authService.clearSession();
    this.router.navigateByUrl("login");
  }

  public goBack() {
    if (this.router.url.split("/").length === 3) {
      this.router.navigate(this.router.url.split("/").slice(0, -1));
    } else if (this.router.url.split("/").length === 5) {
      this.router.navigate(this.router.url.split("/").slice(0, -2));
    }
  }

  public showBackButton(): boolean {
    return (
      this.isScreenNarrowEnoughForBackButton() &&
      this.doShowBackButtonOnCurrentUrl()
    );
  }

  private resetButtons() {
    this.isAccountButtonActive = false;
    this.isAccountButtonActive = false;
  }

  private isScreenNarrowEnoughForBackButton(): boolean {
    return true;
    /*return (
      window.screen.width <=
      this.applicationConfig.MAX_RESOLUTION_TO_SHOW_BACK_BUTTON
    );*/
  }

  private doShowBackButtonOnCurrentUrl(): boolean {
    return this.router.url.split("/").length > 2;
  }

  public setInterventionTeam(team: InterventionTeam) {
    this.interventionTeamService.setTeam(team);
  }

  public getUserInitials(){
    return this.getUsername().match(/(^\S\S?|\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase();
  }

  public onAddIssue(){
      this.sidenav.hide();
      const dialogRef = this.dialog.open(IssueDialogComponent,{
        width: '100%',
        height: '100%',
        maxWidth: 'inherit',
        data: this.buildingId,
        panelClass: 'custom-dialog-bg-color',

      })

      dialogRef.afterClosed().subscribe((saved) => {
        if(saved){
          this.snackBar.open(this.translate.instant(this.Localization.IssueSavedAndSend), null, {
            duration: 3000
          })
        }
      })
  }
}
